// removed by extract-text-webpack-plugin
module.exports = {"close":"_1VzpTiZsOBHfjHAS8sqeWW","component":"_2guTUa9_D8EBL1YWK20TWA","modalContent":"_3AMhsM3eoWtMo-XJMrheCA","headerImg":"_11vq9YLt7_O-MDxTEgirOC","header":"_3TCkmYQhjaPz4Hnw-c9O7q","title":"LUSYLoJTA0JLiYBtIdUw0","tail":"_1YeMwX1Yixpx8-p41w_S29","itemTitle":"_3BthuuHboeDtlkJ5GkQB7M","itemContent":"_3YcVODyLf0UyU6tJVmcufC","jumpContent":"_2ywwF_og5tiH10Tz1PXiRr","choosenBtn":"_1O40e-zVdjaeaYo3OtylHz","bottomDiv":"_2LiNmTh_PmRKV66HBYavCs","submitBtn":"GcwnVyqkWG7-rcTbXDT47","allPrice":"RNJTJyVrBVjcZdF38IIYk","zhuan_a":"_3s8n9ol5hiPoLfG0S0qnnt","zhuan":"_8hOVVAhQLjrGYkWGWjCLG"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CustomProductDetailTipModal/CustomProductDetailTipModal.scss
 ** module id = 179
 ** module chunks = 0
 **/